module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/map#map"
    }
  }, [_vm._v("Map")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/char#char"
    }
  }, [_vm._v("Main Characters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#pt1"
    }
  }, [_vm._v("Part I: Sun Among Women")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("1. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Blood in the Sand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("2. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("The Assassin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("3. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Widow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("4. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Imperial Haram")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("5. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Meena Bazaar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("6. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Executioner’s Sword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("7. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Absolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("8. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Light of the Palace’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("9. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life and Death")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("10. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Lord of the World’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("11. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Red Velvet Coach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("12. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Poison Pen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("13. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Abyssinian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("14. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Enemy Within")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_vm._v("15. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Homecoming")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: Outcasts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("16. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asirgarh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("17. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Outlaw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("18. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Kindness of Strangers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("19. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Messenger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("20. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Price")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("21. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Opportunist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("22. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("River of Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("23. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Parting of the Ways")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("24. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Funeral Cortège")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("25. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sins of the Father")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_vm._v("26. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Peacock Throne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/note#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historical Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/add#add",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#ad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Alex Rutherford")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0